import { Modal } from "./modal";

const StartShift = { Modal };

export default StartShift;
